import http from "@/axiosConfig";
import toast from "@/global/ToastConfig";
const integrationRoutes = {
    FIND_BY_TYPE: "/dashboard/report/integration/property/find"
}
export default {
    findByType(objParams){
        return new Promise(resolve => {
            let newData = {};
            http.get(integrationRoutes.FIND_BY_TYPE, {params: objParams})
                .then(({data}) => {
                    const code = data.code;
                    if (code < 0) {
                        toast.error(data.message)
                        return;
                    }
                    newData = data;
                }).catch(() => toast.error("No se pudo realizar la conexión con el servidor"))
                .finally(() => resolve(newData));
        })
    }
}